module.exports = __webpack_public_path__ + "img/HC1029-25.6abe221e.jpg";